<script>
	import { fade } from 'svelte/transition';
	import { scaleAdOnHover, startAd, pauseAd, stopAd } from '../../../../share/ads';
	import { getText } from '../../../../share/utils';

	let ads = {
		// Touareg
		touareg: {
			element: false,
			fallbackImgUrl: './../video/Titelbild_Touareg_Launch.webp',
			imageAltText: 'Touareg - interactive Ad',
			videoUrl: './../video/VW-SK023_Touareg_Video-Snippet_Ads_Neugier_PF_2.mp4',
			playTimeMs: 8000,
			maxScale: 1,
			playing: false,
			autoStopTimeOut: false,
			volume: 0,
			showPauseButton: false,
			pauseImgOffsetS: 4
		},
		// Scheinwerferleuchten_K
		starwars: {
			element: false,
			fallbackImgUrl: './../video/star_wars_auto_poster.webp',
			imageAltText: 'StarWars - interactive Ad',
			videoUrl: './../video/star_wars_auto_1.mp4',
			playTimeMs: 6000,
			maxScale: 1,
			playing: false,
			autoStopTimeOut: false,
			pauseImgOffsetS: 5,
			volume: 0,
			showPauseButton: false,
		},
		// FB_Video_Tiguan_Allspace_Platz_hier_Platz_da_3_1
		platzHier: {
			element: false,
			fallbackImgUrl:
					'./../img/18.BurgEins_Stromert/02.advent/FB_Video_Tiguan_Allspace_Platz_hier_Platz_da_3_1_Poster.webp',
			imageAltText: 'Platz hier - interactive Ad',
			videoUrl: './../video/FB_Video_Tiguan_Allspace_Platz_hier_Platz_da_3_1.mp4',
			playTimeMs: 12000,
			maxScale: 1,
			playing: false,
			autoStopTimeOut: false,
			pauseImgOffsetS: 4,
			volume: 0,
			showPauseButton: false
		},
		// driving_home
		handy: {
			element: false,
			fallbackImgUrl: './../img/18.BurgEins_Stromert/02.advent/Gruppe386.webp',
			imageAltText: 'Driving Home - interactive Ad',
			videoUrl: './../video/klima_9-16.mp4',
			playTimeMs: 31000,
			maxScale: 1,
			playing: false,
			autoStopTimeOut: false,
			pauseImgOffsetS: 0,
			volume: .2,
			showPauseButton: false
		}
	}
</script>

<div class="page-menschen_bewegen-launch marginbox">
	<div class="img-single">
		<div bind:this={ads.touareg.element} class="flex element">
			<div use:scaleAdOnHover={ads.touareg} class="commercial" class:playing={ads.touareg.playing} on:click={() =>
			!ads.touareg.playing ? startAd(ads.touareg, () => ads = ads) : null}>
				<video playsinline loop="true"
					   on:loadeddata={() => stopAd(ads.touareg, () => ads = ads)}
					   on:mousemove={() => {ads.touareg.showPauseButton = true; setTimeout(() => {
								   ads.touareg.showPauseButton = false;
							   }, 2000)}}
					   scrolling="no"
					   src={ads.touareg.videoUrl}
				/>
				{#if ads.touareg.playing}
					<!-- PLAYING -->
					{#if ads.touareg.showPauseButton}
						<button aria-label="pause Ad - {ads.touareg.imageAltText}" transition:fade class="pausebutton"
								on:click={() => pauseAd(ads.touareg, () => ads = ads)}></button>
					{/if}
				{:else}
					<!-- NOT PLAYING -->
					<button aria-label="play Ad - {ads.touareg.imageAltText}" class="playbutton"></button>
				{/if}
			</div>
		</div>
	</div>

	<div class="flex structure">
		<div class="flex col structure-1">
			<div class="flex element">
				<!-- Beginning - starwars -->
				<div bind:this={ads.starwars.element} class="flex element">
					<div use:scaleAdOnHover={ads.starwars} class="commercial" class:playing={ads.starwars.playing} on:click={() => !ads.starwars.playing ? startAd(ads.starwars, () => ads = ads) : null}>
						<video playsinline loop="true"
							   on:loadeddata={() => stopAd(ads.starwars, () => ads = ads)}
							   on:mousemove={() => {ads.starwars.showPauseButton = true; setTimeout(() => {
								   ads.starwars.showPauseButton = false;
							   }, 2000)}}
							   scrolling="no"
							   src={ads.starwars.videoUrl}
						/>
						{#if ads.starwars.playing}
							<!-- PLAYING -->
							{#if ads.starwars.showPauseButton}
								<button aria-label="pause Ad - {ads.starwars.imageAltText}" transition:fade class="pausebutton"
										on:click={() => pauseAd(ads.starwars, () => ads = ads)}></button>
							{/if}
						{:else}
							<!-- NOT PLAYING -->
							<button aria-label="play Ad - {ads.starwars.imageAltText}" class="playbutton"></button>
						{/if}
					</div>
				</div>
				<!-- End - starwars -->
			</div>
			
			<div class="flex element">
				<!-- Beginning - platzHier -->
				<div bind:this={ads.platzHier.element} class="flex element">
					<div use:scaleAdOnHover={ads.platzHier} class="commercial" class:playing={ads.platzHier.playing}
						 on:click={() => !ads.platzHier.playing ? startAd(ads.platzHier, () => ads = ads) : null}>
						<video playsinline loop="true"
							   on:loadeddata={() => stopAd(ads.platzHier, () => ads = ads)}
							   on:mousemove={() => {ads.platzHier.showPauseButton = true; setTimeout(() => {
								   ads.platzHier.showPauseButton = false;
							   }, 2000)}}
							   scrolling="no"
							   src={ads.platzHier.videoUrl}
						/>
						{#if ads.platzHier.playing}
							<!-- PLAYING -->
							{#if ads.platzHier.showPauseButton}
								<button aria-label="pause Ad - {ads.platzHier.imageAltText}" transition:fade class="pausebutton"
										on:click={() => pauseAd(ads.platzHier, () => ads = ads)}></button>
							{/if}
						{:else}
							<!-- NOT PLAYING -->
							<button aria-label="play Ad - {ads.platzHier.imageAltText}" class="playbutton"></button>
						{/if}
					</div>
				</div>
				<!-- End - platzHier -->
			</div>
		</div>
		
		<div class="flex col structure-2">
			<div class="flex element">
				<div class="text">
					<h2>{getText("12.02.01_h2")}</h2>
					<p class="caption">{getText("12.02.02_caption")}</p>
					<p class="caption blue">Project Lead: Burg Eins & <a href="//thesocialchain.ag" target="_blank">SocialChain (Berlin)</a></p>
				</div>
			</div>
			
			<div class="flex element">
				<img loading="lazy" alt="Menschen bewegen - Smileys - Ad-Design" src="./../img/12.Menschen_Bewegen/02.launch/smileys.webp">
			</div>
		</div>
	</div>
</div>

<style lang="scss">
	@import "../../../../style/mixins";
	@import "../../../../style/variables";
	
	img {
		width: 100%;
		margin: 0;
		padding: 0;
	}
	
	.img-single {
		margin: $spacing-mobile 0 $media-gap 0;
	}
	
	.page-menschen_bewegen-launch {
		.flex {
			display: flex;
			box-sizing: border-box;
		}
		
		.row {
			flex-flow: row wrap;
		}
		
		.col {
			flex-flow: column wrap;
		}
		
		.element {
			min-width: 100px;
			width: 100%;
		}
		
		.commercial {
			position: relative;
			width: 100%;
			height: auto;
			line-height: 0;
		}
		
		.content {
			flex: 1 100%;
		}
		
		.structure {
			flex-flow: row wrap;
		}
		
		.structure-1,
		.structure-2 {
			> .element {
				width: 100%;
				margin-bottom: $media-gap;
				height: fit-content;
			}
		}
		
		.structure-1 {
			width: 100%;
			margin-bottom: $media-gap;
			padding: 0;
			align-self: end;
			
			@include for-tablet-portrait-up {
				width: 50%;
			}
		}
		
		.structure-2 {
			width: 100%;
			padding: 0;
			
			@include for-tablet-portrait-up {
				width: 50%;
				padding-left: $media-gap;
			}
		}
		
		.text {
			margin: 0;
		}

		.commercial video {
			width: 100%;
		}
	}
</style>
